<template>
  <div class="header-main">
    <!-- <img v-if="faceIcon&&faceIcon.length" class="header-main-top" :src="faceIcon" @click="loginDailogClick" />
        <img v-else class="header-main-top" src="https://imagessl.edujia.com/A-1ed71af7_20230804094317.png" /> -->
    <!-- <div v-if="loginDailogShow" class="loginDialogCover" :style="{'width':pageWidth+'px','height':pageHeight+'px'}" @click="loginDailogClick"> -->
    <div
      class="loginDialogCover"
      :style="{ width: pageWidth + 'px', height: pageHeight + 'px' }"
      @click="loginDailogClick"
    >
      <div class="loginDialog">
        <div class="loginDialogTop">
          <div class="loginDialogTopL">
            <img
              class="faceIcon"
              :src="faceIcon"
            />
            <img
              v-if="isVip.length"
              class="vipIcon"
              src="https://imagessl.edujia.com/A-1ed71af7_20230807161652.png"
            />
          </div>
          <div class="loginDialogTopR">
            <div class="nickName">{{ nickName }}</div>
            <div class="userId">用户ID：{{ userId }}</div>
            <!-- <div v-if="isVip" class="validate">有效期：{{$common.format(new Date(isVip),"yyyy-MM-dd")}}</div> -->
            <div
              v-if="isVip.length"
              class="validate"
            >
              有效期：{{ isVip }}
            </div>
          </div>
        </div>
        <div
          class="loginDialogBottom"
          @click="loginOut"
        >
          退出登录
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isWeb: {
      type: Boolean,
      default: false,
    },
  },
  name: "Header",
  data() {
    return {
      nickName: "",
      faceIcon: "",
      userId: "",
      validate: "",
      isVip: 0,
      loginDailogShow: false,
      pageWidth: document.documentElement.clientWidth,
      pageHeight: document.documentElement.clientHeight,
    };
  },
  mounted() {
    this.faceIcon = localStorage.getItem("edujia:group:web:faceIcon");
    this.nickName = localStorage.getItem("edujia:group:web:userName");
    this.userId = localStorage.getItem("edujia:group:web:userid");
    this.isVip = localStorage.getItem("edujia:group:web:isVip");
  },
  methods: {
    loginDailogClick() {
      // this.loginDailogShow=!this.loginDailogShow;
      this.$emit("hide");
    },
    loginOut() {
      sessionStorage.clear();
      localStorage.clear();
      this.$store.commit("resetUserState");
      // 原来的 commit("token", null) 不是已注册的 mutation 名（应为 modifyToken），
      // 会在控制台报 unknown mutation type，顺手改正
      this.$store.commit("modifyToken", null);
      const loginName = this.isWeb ? "wlogin" : "login";
      // 退出登录必须"一定"落到登录页。
      // 缺陷：原来 router.push 之后 100ms 就 window.location.reload()，而 push 是
      // 异步导航（登录页 chunk 现拉 / 路由守卫异步），URL 还没更新就 reload 会重新
      // 加载"当前页"（#/home）；此时 token 已清空、页面又没有任何守卫，用户就永久
      // 卡在空白首页：现场表现就是"退出登录后登录不上去"。
      // 这里改成同步跳转：hash 模式先同步改 hash，再整页刷新（顺便清掉 keep-alive
      // 缓存里的首页）；history 模式直接用整页跳转。
      let href = "";
      try {
        href = this.$router.resolve({ name: loginName }).href || "";
      } catch (e) {}
      if (href && href.charAt(0) === "#") {
        if (window.location.hash !== href) window.location.hash = href;
        setTimeout(() => {
          window.location.reload();
        }, 100);
      } else if (href) {
        window.location.href = href;
      } else {
        setTimeout(() => {
          window.location.reload();
        }, 100);
      }
    },
  },
};
</script>

<style scoped>
.header-main {
  /*width: 100%;
        height: 57px;
        display: flex;
        align-items: center;
        justify-content: flex-end;*/
}

.header-main-top {
  width: 32px;
  height: 32px;
  margin-right: 14px;
  object-fit: cover;
}

.loginDialogCover {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100000;
}

.loginDialog {
  background-image: url("https://imagessl.edujia.com/A-1ed71af7_20230807160904.png");
  width: 261px;
  height: 189px;
  background-size: 261px 189px;
  position: absolute;
  right: 0px;
  /*        top: 28px;*/
  top: 68px;
}

.loginDialogTop {
  display: flex;
}

.loginDialogTopL {
  position: relative;
  margin-top: 32px;
  margin-left: 24px;
  width: 40px;
  height: 40px;
}

.loginDialogTopR {
  margin-top: 32px;
  margin-left: 14px;
}

.faceIcon {
  width: 40px;
  height: 40px;
  border-radius: 40px;
}

.vipIcon {
  width: 24px;
  height: 13px;
  position: absolute;
  bottom: -6.5px;
  left: 50%;
  margin-left: -12px;
}

.nickName {
  font-size: 16px;
  color: #3c3c3c;
  font-weight: 500;
}

.userId {
  margin-top: 8px;
  font-size: 14px;
}

.validate {
  margin-top: 8px;
  font-size: 14px;
}

.loginDialogBottom {
  width: 120px;
  height: 32px;
  border: 1px solid #4a90e2;
  border-radius: 4px;
  color: #4a90e2;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  margin-top: 5px;
}
</style>
